import Glide from '@glidejs/glide'
import Masonry from 'masonry-layout'
//import { gsap } from "gsap";
// Add your custom JS here.

( function( $ ) {

	var kkvOffcanvas = document.getElementById('navbarNavOffcanvas');
	kkvOffcanvas.addEventListener('show.bs.offcanvas', function () {
		document.querySelector( '.navbar-kkv .navbar-toggler' ).classList.remove('collapsed');
		document.querySelector( '.navbar-kkv .navbar-brand img' ).classList.add('nofilter');
	})
	kkvOffcanvas.addEventListener('hide.bs.offcanvas', function () {
		document.querySelector( '.navbar-kkv .navbar-toggler' ).classList.add('collapsed');
		document.querySelector( '.navbar-kkv .navbar-brand img' ).classList.remove('nofilter');
	})
	
	$(document).ready( function ()
	{
		$(document).on('gform_confirmation_loaded', function(event, formId){
			document.querySelectorAll( '.quote-row' ).forEach(e => e.remove() );
		});
	//});
	
	//$(window).on("load", function()
	//{
		let elm = document.querySelector(".fx-header");
		if ( elm )
		{
			const fxElm = document.createElement("canvas");
			fxElm.classList.add( 'fx-canvas' );
			elm.insertAdjacentElement("afterbegin", fxElm );
		}
		/*let projectTitle = document.getElementById("portfolio-project-h1");
		if ( projectTitle != null && projectTitle.innerHTML.length > 30 )
		{
			projectTitle.classList.add('long');			
		}*/
		if ( document.getElementById("project-listing") != null )
		{
			var glide= new Glide('#project-listing', {
				type: 'carousel',
				startAt: 0,
				perView: 5,
				focusAt: 'center',
				gap: 30,
				//autoplay: 8000,
				animationDuration: 1600,
				//animationTimingFunc: 'ease-in-out',
				breakpoints: {
					1399: {
						perView: 4,
					},
					1199: {
						perView: 3,
					},
					991: {
						perView: 2,	
					},
					767: {
						perView: 2,
					},
					575: {
						perView: 1,
					}
				}
			}).mount()
			glide.on( 'move', (movement) => {
				$('#project-listing .glide__slide--active h4').css( 'height', '0px' );
				$('#project-listing .glide__slide--active').removeClass( 'glide__slide--active' );
				//$('#project-listing .glide__slide--active + div h4').css( 'height', '6.1rem' );
			});
			glide.on( 'move.after', () => {
				$('#project-listing .glide__slide--active h4').css( 'height', '6.1rem' );
			});
		}
		
		if ( document.getElementById("services-slider") != null )
		{
			var glide= new Glide('#services-slider', {
				type: 'carousel',
				startAt: 0,
				perView: 4,
				focusAt: 'center',
				gap: 100,
				//autoplay: 8000,
				animationDuration: 1600,
				//animationTimingFunc: 'ease-in-out',
				breakpoints: {
					1399: {
						perView: 3,
					},
					1199: {
						perView: 3,
					},
					991: {
						perView: 2,	
					},
					767: {
						perView: 2,
					},
					575: {
						perView: 1,
					}
				}
			}).mount();
		}
				
		if ( document.querySelector(".services-grid") )
		{
			var msnry = new Masonry( '.services-grid', {
		  	columnWidth: '.servicegrid-sizer',
			gutter: '.servicegrid-gutter-sizer',
		  	itemSelector: '.service',
		  	percentPosition: true,
			});
		}
		
		if ( document.querySelector(".package-row") )
		{
			const kruken = document.querySelectorAll('.package-row .package');
			const kruken2 = document.querySelector('.package-row');
			const scrollVal = 46 + ((kruken[0].offsetWidth * kruken.length) - kruken2.offsetWidth) / 2;
			kruken2.scrollTo( { left: scrollVal } );
			//alert( kruken[0].getBoundingClientRect().width );
			//alert( scrollVal );
		}
		
		const elements = document.getElementsByClassName("btn-remove");
		Array.from(elements).forEach( function(element) {
			element.addEventListener( 'click', async function() {
				const data = new FormData();
				data.append( "action", "remove_from_cart" );
				data.append( "security", kkv_ajax.nonce );
				data.append( "itemtype", this.dataset.itemtype );
				data.append( "itemid", this.dataset.itemid )
				try
				{
					const responseAjax = await fetch( kkv_ajax.url,
						{
							method: "POST",
							credentials: "same-origin",
							body: data,
						},
				 	);
					const jsonRes = await responseAjax.json();
					this.parentElement.remove();
					if ( jsonRes.emptycart) location.reload();
					//alert( JSON.stringify( jsonRes ) );
				} catch (err) {
					alert('Error Flynn');
				}
			});
		});
		
		const elmAddtocart = document.getElementsByClassName("btn-add-to-cart");
		Array.from(elmAddtocart).forEach( function(element) {
			element.addEventListener( 'click', async function() {
				event.preventDefault();
				if ( this.innerHTML==="Visa offert")
				{
					window.location.replace( "/offert" );
				}
				else
				{
					const data = new FormData();
					data.append( "action", "add_to_cart" );
					data.append( "security", kkv_ajax.nonce );
					data.append( "postid", this.dataset.postid );
					data.append( "itemtype", this.dataset.itemtype );
					data.append( "itemid", this.dataset.itemid );
					data.append( "itemdesc", this.dataset.itemdesc );
					try
					{
						const responseAjax = await fetch( kkv_ajax.url,
							{
								method: "POST",
								credentials: "same-origin",
								body: data,
							},
						);
						const jsonRes = await responseAjax.json();
						this.blur();
						this.innerHTML = 'Visa offert';
						this.classList.add( 'active' );
					} catch (err) {
						alert( 'Error Flynn' );
					}
				}
			});
		});
		
		if ( document.getElementById("btn-send-quote") )
		{
			document.getElementById("btn-send-quote").addEventListener( "click", async function() {
				event.preventDefault();
				document.querySelectorAll( '.btn-remove' ).forEach(e => e.remove() );
				document.getElementById( "btn-send-quote" ).style.display = 'none';
				document.getElementById("quote-form-container").style.display = 'block';
				document.getElementById("input_2_2").focus();
			} );
		}
		
		const readmooreElements = document.getElementsByClassName("readmoore-trigger");
		Array.from(readmooreElements).forEach( function(element) {
			element.addEventListener( 'click', function() {
				this.classList.toggle('active');
				document.getElementById( this.dataset.targetid ).classList.toggle('active');
			});
		});
	});

} )( jQuery );